<script>
  let y;

  /* ScrollBackToTop */
  const scrollUp = () => {
    window.scrollTo ({
      top: 0,
      behavior: "smooth"
    });
  }
</script>

<svelte:window bind:scrollY={y} />

<!-- Markup -->
{#if y > 120 }
  <div class="fixed bottom-0 right-0 m-8 z-20">
    <button class="border-4 border-teal_d shadow-lg px-4 pb-1 rounded-full bg-teal text-snow
                   hover:outline-none hover:bg-teal_d transition-colors duration-200" on:click="{scrollUp}">
      <i class="inline-block arrow border-b border-b-snow"></i>
    </button>
  </div>
{/if}


<style>
  .arrow {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 10px solid;
  }
</style>
